module.exports = __webpack_public_path__ + "static/media/devpost.13628ccc.png";